// extracted by mini-css-extract-plugin
export default {"main":"main_main__26-hL","sidebar-open":"main_sidebar-open__76znx","sidebar-close":"main_sidebar-close__74uRj"};